import { useContext } from 'react';

import type { UpgradeContextType } from './types';
import { UpgradeContext } from './UpgradeContext';

export const useUpgradeContext = () => {
  const context = useContext<UpgradeContextType>(UpgradeContext);
  if (!context) {
    throw new Error('useUpgradeContext must be used within a UpgradeProvider');
  }
  return context;
};
